import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './lang/en'
const { REACT_APP_LNG } = process.env

const resources = {
    en: {
        translation: en,
    },
}

i18n.use(initReactI18next).init({
    debug: false,
    resources,
    lng: REACT_APP_LNG || 'en',
    fallbackLng: REACT_APP_LNG || 'en',
    interpolation: {
        escapeValue: false,
    },
})

export const dateLocales = {
    en: () => import('dayjs/locale/en'),
}

export const languageList = [{ label: 'English', value: 'en', flag: 'us' }]

export default i18n
